import { useTranslation } from 'react-i18next';
import { setTheme, ThemeChoice, useTheme } from '../../lib/theme';
import { Segmented } from './Segmented';

const CHOICES: ThemeChoice[] = ['system', 'light', 'dark'];

/** System / Light / Dark. Applies at once and is remembered in this browser. */
export const ThemeSwitch = ({ className }: { className?: string }) => {
    const { t } = useTranslation();
    const { choice } = useTheme();
    return (
        <Segmented
            aria-label={t('theme.label')}
            className={className}
            value={choice}
            onChange={setTheme}
            options={CHOICES.map((value) => ({ value, label: t(`theme.${value}`) }))}
        />
    );
};
